module.exports = __webpack_public_path__ + "media/images/ours_fav_big-6338b44608871d510913802b071d24ce.png";